import { useState, useEffect } from 'react';
import { money, fmtDateTime } from '../util';
import RuletaEvento from './RuletaEvento';

export default function TabPromociones({ event, api }) {
  const [kind, setKind] = useState('volumen');
  const [volType, setVolType] = useState('2x1');
  const [pct, setPct] = useState('');
  const [lotes, setLotes] = useState([]);
  // La condición dejó de ser texto libre: ahora son dos campos que el sistema puede
  // hacer cumplir de verdad. Antes se escribía "las primeras 150" y nadie las contaba.
  const [vence, setVence] = useState('');
  const [tope, setTope] = useState('');
  // "Todos los lotes" para las promos, igual que ya lo tenía el cupón: con 15 lotes,
  // tildarlos uno por uno es la parte lenta de armar una promo.
  const [todosLotes, setTodosLotes] = useState(false);
  const [promos, setPromos] = useState([]);
  // cupones
  const [cName, setCName] = useState('');
  const [cCode, setCCode] = useState('');
  const [cType, setCType] = useState('percent');
  const [cValue, setCValue] = useState('');
  const [cAllLots, setCAllLots] = useState(true);
  const [cExpires, setCExpires] = useState('');
  const [cMax, setCMax] = useState('');
  const [coupons, setCoupons] = useState([]);
  // Si la compra online muestra cuántas quedan. Es del boliche (null = todavía no cargó).
  const [mostrarStock, setMostrarStock] = useState(null);
  // Promo que se está editando (id) y los dos campos editables.
  const [editId, setEditId] = useState(null);
  const [eTope, setETope] = useState('');
  const [eVence, setEVence] = useState('');
  const lots = event.lots || [];

  const load = () => api.get(`/api/promotions?event_id=${event.id}`).then(setPromos).catch(() => {});
  const loadCoupons = () => api.get(`/api/coupons?event_id=${event.id}`).then(setCoupons).catch(() => {});
  useEffect(() => {
    load(); loadCoupons();
    api.get('/api/org').then(o => setMostrarStock(o?.mostrar_stock !== false)).catch(() => {});
  }, []); // eslint-disable-line

  async function toggleStock() {
    const next = !mostrarStock;
    setMostrarStock(next);
    try { await api.patch('/api/org', { mostrar_stock: next }); }
    catch (e) { setMostrarStock(!next); alert(e.message); }
  }

  const toggleLote = (id) => setLotes(ls => ls.includes(id) ? ls.filter(x => x !== id) : [...ls, id]);

  async function add() {
    if (!todosLotes && !lotes.length) return;
    if (kind === 'percent' && !pct) return;
    const lot_names = todosLotes ? [] : lotes.map(id => (lots.find(t => t.id === id) || {}).name).filter(Boolean);
    const type = kind === 'volumen' ? volType : 'percent';
    const head = kind === 'volumen' ? volType : (pct + '% off');
    try {
      await api.post('/api/promotions', {
        // Lista vacía = todos los lotes. Va con `all_lots` explícito para que el backend
        // pueda distinguirlo de "me olvidé de tildar" — una promo aplicada a todo por
        // accidente es plata regalada.
        event_id: event.id, type, lot_ids: todosLotes ? [] : lotes, lot_names, all_lots: todosLotes,
        discount_value: kind === 'percent' ? (+pct || 0) : 0,
        expires_at: vence || null,
        max_qty: tope ? Number(tope) : null,
        label: head,
      });
      setLotes([]); setPct(''); setVence(''); setTope(''); setTodosLotes(false); load();
    } catch (e) { alert(e.message); }
  }
  async function del(id) { try { await api.del(`/api/promotions/${id}`); load(); } catch (e) { alert(e.message); } }

  // Editar una promo ya creada: solo cantidad y vencimiento (ver el comentario de la ruta).
  function empezarEdicion(d) {
    setEditId(d.id);
    setETope(d.max_qty > 0 ? String(d.max_qty) : '');
    setEVence(paraInput(d.expires_at));
  }
  async function guardarEdicion(id) {
    try {
      await api.patch(`/api/promotions/${id}`, { max_qty: eTope === '' ? null : Number(eTope), expires_at: eVence || null });
      setEditId(null); load();
    } catch (e) { alert(e.message); }
  }

  async function addCoupon() {
    if (!cName.trim() || !cCode.trim() || !cValue) return;
    try {
      await api.post('/api/coupons', {
        event_id: event.id,
        name: cName.trim(),
        code: cCode.trim().toUpperCase(),
        discount_type: cType,
        discount_value: +cValue || 0,
        lot_ids: cAllLots ? [] : lotes,
        expires_at: cExpires || null,
        max_uses: cMax || null,
      });
      setCName(''); setCCode(''); setCValue(''); setCExpires(''); setCMax(''); setLotes([]); setCAllLots(true);
      loadCoupons();
    } catch (e) { alert(e.message); }
  }
  async function delCoupon(id) { try { await api.del(`/api/coupons/${id}`); loadCoupons(); } catch (e) { alert(e.message); } }
  async function toggleCoupon(c) { try { await api.patch(`/api/coupons/${c.id}`, { active: !c.active }); loadCoupons(); } catch (e) { alert(e.message); } }

  const LoteChecks = ({ label = 'Lotes a los que aplica' }) => (
    <div className="lb-field">
      <div className="lb-label">{label}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {lots.map(t => {
          const on = lotes.includes(t.id);
          return (
            <button key={t.id} type="button" onClick={() => toggleLote(t.id)} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', background: on ? 'rgba(255,255,255,0.05)' : 'var(--ink-050)', border: '1px solid ' + (on ? 'rgba(255,255,255,0.45)' : 'var(--border)'), padding: '11px 13px', textAlign: 'left', borderRadius: 4 }}>
              <span style={{ width: 17, height: 17, flex: 'none', border: '1px solid ' + (on ? 'var(--red-500)' : 'var(--ink-500)'), background: on ? 'var(--red-600)' : 'transparent', display: 'grid', placeItems: 'center', color: '#fff', fontSize: 12 }}>{on ? '✓' : ''}</span>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', color: '#fff' }}>{t.name}</span>
              <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--ink-700)' }}>{money(t.price)}</span>
            </button>
          );
        })}
        {lots.length === 0 && <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>Creá primero los lotes en Productos.</div>}
      </div>
    </div>
  );

  // La ruleta ocupa todo el ancho: tiene su configuración, la vista previa y la lista de
  // quienes jugaron, y no entra en la columna angosta de los otros tipos de promo.
  if (kind === 'ruleta') return (
    <div className="lb-fade" style={{ paddingTop: 30 }}>
      <div style={{ display: 'flex', gap: 8, maxWidth: 560 }}>
          {[['volumen', 'Por volumen'], ['percent', 'Descuento %'], ['cupon', 'Cupón'], ['ruleta', 'Ruleta']].map(([k, lbl]) => (
          <button key={k} onClick={() => setKind(k)} className={'lb-btn lb-btn--sm ' + (kind === k ? 'lb-btn--white' : 'lb-btn--ghost')} style={{ flex: 1 }}>{lbl}</button>
        ))}
      </div>
      <RuletaEvento event={event} api={api} />
    </div>
  );

  return (
    <div className="lb-fade tk-2col" style={{ paddingTop: 30, display: 'grid', gridTemplateColumns: '1fr 1.1fr', gap: 30, alignItems: 'start' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {[['volumen', 'Por volumen'], ['percent', 'Descuento %'], ['cupon', 'Cupón'], ['ruleta', 'Ruleta']].map(([k, lbl]) => (
            <button key={k} onClick={() => setKind(k)} className={'lb-btn lb-btn--sm ' + (kind === k ? 'lb-btn--white' : 'lb-btn--ghost')} style={{ flex: 1 }}>{lbl}</button>
          ))}
        </div>

        <div className="lb-card" style={{ padding: '24px 26px' }}>
          {kind === 'volumen' && (
            <>
              <div className="lb-eyebrow" style={{ marginBottom: 16 }}>Promo por volumen</div>
              <div className="lb-field"><div className="lb-label">Tipo de promo</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {['2x1', '3x2', '4x3'].map(v => (
                    <button key={v} onClick={() => setVolType(v)} className={'lb-btn lb-btn--sm ' + (volType === v ? 'lb-btn--primary' : 'lb-btn--ghost')} style={{ flex: 1, fontFamily: 'var(--font-display)' }}>{v}</button>
                  ))}
                </div>
              </div>
              <div style={{ height: 16 }} />
              <TodosLosLotes on={todosLotes} onClick={() => setTodosLotes(v => !v)} />
              {!todosLotes && <LoteChecks label="Lotes específicos" />}
              <div style={{ height: 16 }} />
              <CondicionesPromo vence={vence} setVence={setVence} tope={tope} setTope={setTope} />
              <button className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 18 }} onClick={add} disabled={!todosLotes && !lotes.length}>Crear promoción →</button>
            </>
          )}

          {kind === 'percent' && (
            <>
              <div className="lb-eyebrow" style={{ marginBottom: 16 }}>Descuento porcentual</div>
              <div className="lb-field"><div className="lb-label">% de descuento</div><input className="lb-input" value={pct} inputMode="numeric" onChange={e => setPct(e.target.value.replace(/\D/g, '').slice(0, 3))} placeholder="50" /></div>
              <div style={{ height: 16 }} />
              <TodosLosLotes on={todosLotes} onClick={() => setTodosLotes(v => !v)} />
              {!todosLotes && <LoteChecks label="Lotes específicos" />}
              <div style={{ height: 16 }} />
              <CondicionesPromo vence={vence} setVence={setVence} tope={tope} setTope={setTope} />
              <button className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 18 }} onClick={add} disabled={(!todosLotes && !lotes.length) || !pct}>Crear promoción →</button>
            </>
          )}

          {kind === 'cupon' && (
            <>
              <div className="lb-eyebrow" style={{ marginBottom: 16 }}>Cupón de descuento</div>
              <div className="lb-field"><div className="lb-label">Nombre del cupón</div><input className="lb-input" value={cName} onChange={e => setCName(e.target.value)} placeholder="Cumpleañeros junio" /></div>
              <div className="lb-field"><div className="lb-label">Código</div><input className="lb-input" value={cCode} onChange={e => setCCode(e.target.value.toUpperCase().replace(/\s/g, ''))} placeholder="JUNIO20" /></div>
              <div className="lb-field"><div className="lb-label">Tipo de descuento</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {[['percent', 'Porcentaje %'], ['fixed', 'Monto fijo $']].map(([k, lbl]) => (
                    <button key={k} type="button" onClick={() => setCType(k)} className={'lb-btn lb-btn--sm ' + (cType === k ? 'lb-btn--primary' : 'lb-btn--ghost')} style={{ flex: 1 }}>{lbl}</button>
                  ))}
                </div>
              </div>
              <div className="lb-field"><div className="lb-label">{cType === 'fixed' ? 'Monto a descontar ($)' : '% de descuento'}</div>
                <input className="lb-input" value={cValue} inputMode="numeric" onChange={e => setCValue(e.target.value.replace(/\D/g, '').slice(0, cType === 'fixed' ? 9 : 3))} placeholder={cType === 'fixed' ? '2000' : '20'} />
              </div>
              <div className="lb-field"><div className="lb-label">Vencimiento (opcional)</div><input type="date" className="lb-input" value={cExpires} onChange={e => setCExpires(e.target.value)} /></div>
              <div className="lb-field"><div className="lb-label">Máximo de usos (opcional)</div><input className="lb-input" value={cMax} inputMode="numeric" onChange={e => setCMax(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="ilimitado" /></div>
              <div className="lb-field">
                <button type="button" onClick={() => setCAllLots(a => !a)} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', background: 'var(--ink-050)', border: '1px solid var(--border)', padding: '11px 13px', textAlign: 'left', borderRadius: 4, width: '100%' }}>
                  <span style={{ width: 17, height: 17, flex: 'none', border: '1px solid ' + (cAllLots ? 'var(--red-500)' : 'var(--ink-500)'), background: cAllLots ? 'var(--red-600)' : 'transparent', display: 'grid', placeItems: 'center', color: '#fff', fontSize: 12 }}>{cAllLots ? '✓' : ''}</span>
                  <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', color: '#fff' }}>Aplica a todos los lotes</span>
                </button>
              </div>
              {!cAllLots && <LoteChecks label="Lotes específicos" />}
              <button className="lb-btn lb-btn--primary lb-btn--block" style={{ marginTop: 18 }} onClick={addCoupon} disabled={!cName.trim() || !cCode.trim() || !cValue || (!cAllLots && !lotes.length)}>Crear cupón →</button>
            </>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 26 }}>
        {/* Qué ve el comprador. Va del BOLICHE, no del evento: quien lo oculta lo quiere
            oculto siempre, y apagarlo fiesta por fiesta es olvidárselo en alguna. */}
        {mostrarStock !== null && (
          <div>
            <div className="lb-eyebrow" style={{ marginBottom: 14 }}>Qué ve el comprador</div>
            <button type="button" onClick={toggleStock} className="lb-card" style={{ display: 'flex', alignItems: 'flex-start', gap: 12, cursor: 'pointer', padding: '16px 20px', textAlign: 'left', width: '100%' }}>
              <span style={{ width: 17, height: 17, flex: 'none', marginTop: 1, border: '1px solid ' + (mostrarStock ? 'var(--red-500)' : 'var(--ink-500)'), background: mostrarStock ? 'var(--red-600)' : 'transparent', display: 'grid', placeItems: 'center', color: '#fff', fontSize: 12 }}>{mostrarStock ? '✓' : ''}</span>
              <span>
                <span style={{ display: 'block', fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', color: '#fff' }}>Mostrar cuántas entradas quedan</span>
                <span style={{ display: 'block', fontSize: 12, color: 'var(--ink-700)', marginTop: 5, lineHeight: 1.5 }}>
                  En la compra online: el stock de cada lote (“124 disponibles”) y el cupo de la promo (“quedan 288”).
                  Apagado, el comprador solo ve si un lote está agotado. Vale para todos tus eventos.
                </span>
              </span>
            </button>
          </div>
        )}
        <div>
          <div className="lb-eyebrow" style={{ marginBottom: 14 }}>Promociones activas</div>
          {promos.length === 0 && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Sin promociones. Creá un 2x1/3x2/4x3 o un % sobre uno o varios lotes.</div>}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {promos.map(d => {
              const names = Array.isArray(d.lot_names) ? d.lot_names : [];
              const head = d.type === 'percent' ? (d.discount_value + '%') : d.type;
              return (
                <div key={d.id} className="lb-card" style={{ padding: '16px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                    <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, color: 'var(--red-400)', whiteSpace: 'nowrap' }}>{head}</span>
                    <div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                        {(names.length ? names : ['Todos los lotes']).map((n, i) => <span key={i} style={{ fontSize: 9, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-700)', border: '1px solid var(--border)', padding: '2px 7px', borderRadius: 999 }}>{n}</span>)}
                      </div>
                      {editId === d.id
                        ? <EditarPromo d={d} tope={eTope} setTope={setETope} vence={eVence} setVence={setEVence}
                            onGuardar={() => guardarEdicion(d.id)} onCancelar={() => setEditId(null)} />
                        : <EstadoPromo d={d} />}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 'none' }}>
                    {editId !== d.id && <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => empezarEdicion(d)}>Editar</button>}
                    <button className="lb-iconbtn" onClick={() => del(d.id)}>✕</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div>
          <div className="lb-eyebrow" style={{ marginBottom: 14 }}>Cupones</div>
          {coupons.length === 0 && <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>Sin cupones. Creá uno con código para que tus clientes lo canjeen en el checkout.</div>}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {coupons.map(c => {
              const allLots = !Array.isArray(c.lot_ids) || c.lot_ids.length === 0;
              const lotNames = allLots ? ['Todos los lotes'] : c.lot_ids.map(id => (lots.find(t => t.id === id) || {}).name).filter(Boolean);
              const head = c.discount_type === 'fixed' ? money(c.discount_value) : (Number(c.discount_value) + '%');
              const exp = c.expires_at ? new Date(c.expires_at).toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }) : null;
              return (
                <div key={c.id} className="lb-card" style={{ padding: '16px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14, opacity: c.active ? 1 : 0.5 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, minWidth: 0 }}>
                    <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, color: 'var(--red-400)', whiteSpace: 'nowrap' }}>{head}</span>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>{c.name}</div>
                      <div style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 12, color: 'var(--ink-700)', letterSpacing: '0.05em', marginTop: 2 }}>{c.code}</div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 6 }}>
                        {lotNames.map((n, i) => <span key={i} style={{ fontSize: 9, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-700)', border: '1px solid var(--border)', padding: '2px 7px', borderRadius: 999 }}>{n}</span>)}
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 6 }}>
                        {exp ? `Vence ${exp}` : 'Sin vencimiento'} · {c.max_uses != null ? `${c.used_count}/${c.max_uses} usos` : `${c.used_count} usos`}{!c.active ? ' · inactivo' : ''}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 'none' }}>
                    <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => toggleCoupon(c)}>{c.active ? 'Pausar' : 'Activar'}</button>
                    <button className="lb-iconbtn" onClick={() => delCoupon(c.id)}>✕</button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// Las dos condiciones que el sistema SÍ puede hacer cumplir. Antes esto era un campo de
// texto libre: se escribía "las primeras 150" y no lo controlaba nadie.
function CondicionesPromo({ vence, setVence, tope, setTope }) {
  return (
    <>
      <div className="lb-field">
        <div className="lb-label">Vence (opcional)</div>
        <input className="lb-input" type="datetime-local" value={vence} onChange={e => setVence(e.target.value)} />
      </div>
      <div className="lb-field">
        <div className="lb-label">Solo las primeras N entradas (opcional)</div>
        <input className="lb-input" inputMode="numeric" value={tope}
          onChange={e => setTope(e.target.value.replace(/\D/g, ''))} placeholder="sin límite" />
      </div>
      <div style={{ fontSize: 11, color: 'var(--ink-600)', lineHeight: 1.5, marginTop: -4 }}>
        Se aplica sola en la venta <b style={{ color: '#fff' }}>online</b> y en los <b style={{ color: '#fff' }}>links de RRPP</b>.
        En boletería no. Si el comprador además tiene un cupón, los dos beneficios se suman.
      </div>
    </>
  );
}

// La fecha guardada, en el formato que entiende un <input type="datetime-local"> (hora
// local, sin zona). Sin esto el campo aparece vacío al editar y guardar borraría el
// vencimiento que ya estaba puesto.
function paraInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d)) return '';
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

// Edición de una promo ya creada: cantidad y vencimiento. El tipo y los lotes no se
// editan (ver el comentario de PATCH /api/promotions/:id).
function EditarPromo({ d, tope, setTope, vence, setVence, onGuardar, onCancelar }) {
  const usadas = Number(d.used_qty) || 0;
  const nuevoTope = tope === '' ? null : Number(tope);
  const quedaAgotada = nuevoTope != null && nuevoTope <= usadas;
  return (
    <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div>
        <div className="lb-label">Cantidad a vender con la promo</div>
        <input className="lb-input" inputMode="numeric" value={tope} autoFocus
          onChange={e => setTope(e.target.value.replace(/\D/g, '').slice(0, 7))} placeholder="sin límite" />
      </div>
      <div>
        <div className="lb-label">Vence (opcional)</div>
        <input className="lb-input" type="datetime-local" value={vence} onChange={e => setVence(e.target.value)} />
      </div>
      <div style={{ fontSize: 11, color: quedaAgotada ? 'var(--red-400)' : 'var(--ink-600)', lineHeight: 1.5 }}>
        {usadas > 0 ? `Ya se usaron ${usadas} entradas. ` : ''}
        {quedaAgotada
          ? 'Con esa cantidad la promo queda agotada y deja de aplicarse.'
          : 'Vacío = sin límite. Lo ya vendido no cambia.'}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="lb-btn lb-btn--primary lb-btn--sm" style={{ flex: 1 }} onClick={onGuardar}>Guardar</button>
        <button className="lb-btn lb-btn--ghost lb-btn--sm" style={{ flex: 1 }} onClick={onCancelar}>Cancelar</button>
      </div>
    </div>
  );
}

// Estado real de la promo: cuánto lleva usado y si sigue viva. Sin esto no hay forma de
// saber si el tope ya se agotó.
function EstadoPromo({ d }) {
  const tope = Number(d.max_qty) || 0;
  const usadas = Number(d.used_qty) || 0;
  const vencida = d.expires_at && new Date(d.expires_at) <= new Date();
  const agotada = tope > 0 && usadas >= tope;
  const partes = [];
  if (d.expires_at) partes.push(`${vencida ? 'venció' : 'vence'} el ${fmtDateTime(d.expires_at)}`);
  if (tope > 0) partes.push(`${usadas}/${tope} entradas`);
  else if (usadas > 0) partes.push(`${usadas} entradas usadas`);
  return (
    <div style={{ fontSize: 12, color: 'var(--ink-700)', marginTop: 6 }}>
      {(vencida || agotada) && (
        <span style={{ color: 'var(--ink-600)', fontWeight: 700, marginRight: 6 }}>
          {agotada ? 'AGOTADA' : 'VENCIDA'} ·
        </span>
      )}
      {partes.length ? partes.join(' · ') : 'sin límite'}
      {/* Las promos viejas guardaron su condición como texto y nunca se aplicó: se
          muestra para no perderla, aclarando que no la controla el sistema. */}
      {d.condition_text && (
        <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 3 }}>
          Nota vieja: “{d.condition_text}” <span style={{ color: 'var(--red-400)' }}>(no se aplica sola)</span>
        </div>
      )}
    </div>
  );
}

// "Aplica a todos los lotes" para las promos. Mismo control que ya tenía el cupón: con
// 15 lotes, tildarlos uno por uno era la parte lenta de armar una promo.
function TodosLosLotes({ on, onClick }) {
  return (
    <div className="lb-field">
      <button type="button" onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', background: 'var(--ink-050)', border: '1px solid var(--border)', padding: '11px 13px', textAlign: 'left', borderRadius: 4, width: '100%' }}>
        <span style={{ width: 17, height: 17, flex: 'none', border: '1px solid ' + (on ? 'var(--red-500)' : 'var(--ink-500)'), background: on ? 'var(--red-600)' : 'transparent', display: 'grid', placeItems: 'center', color: '#fff', fontSize: 12 }}>{on ? '✓' : ''}</span>
        <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', color: '#fff' }}>Aplica a todos los lotes</span>
      </button>
    </div>
  );
}
